module.exports = __webpack_public_path__ + "static/img/insights.1e4ca36e.jpg";